import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { api, CreateReviewDto } from '@sib/api';

export const useCreateReview = (
  options?: UseMutationOptions<CreateReviewDto, Error, CreateReviewDto>
) =>
  useMutation({
    ...options,
    mutationFn: async ({ ...data }) =>
      api.review.reviewControllerCreateReview(data),
  });
